export const CATEGORIES_TYPE = "categories";
export const SUBCATEGORIES_TYPE = "subcategories";
export const USERS_TYPE = "users";
export const LOCATIONS_TYPE = "locations";
export const REVIEW_TYPE = "reviews";
export const USERS_BLOCK_TYPE = "blockUser";
export const USERS_UNBLOCK_TYPE = "unblockUser";
export const USERS_DELETE_TYPE = "deleteUser";
export const USERS_APPROVE_TYPE = "approveUser";
